import { IEmployee } from "../../../domain/employees/IEmployee";

export const mapEmployee = (x: any): IEmployee => ({
    id: x.id,
    userName: x.userName,
    startDate: x.startDate,
    exitDate: x.exitDate,
    fullName: x.name,
    showInAbsence: x.showInAbsence,
    userType: x.userType
});
